import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../api/axios";

export interface UploadResponse {
  docId: number;
}

interface Args {
  file: File;
  docTypeId: number;
  uploaderId: number; // lo obtendrás de tu auth context
}

export function useUploadPdf() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ file, docTypeId, uploaderId }: Args): Promise<UploadResponse> => {
      const form = new FormData();
      form.append("file", file);
      form.append("docTypeId", String(docTypeId));
      form.append("uploaderId", String(uploaderId));
      form.append("originalName", file.name);

      const { data } = await api.post("/documentos", form, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          // opcional: emitir % progreso
        },
      });
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["documentos"] }); // si tienes un listado global
    },
  });
}
